import React from "react";
import useAppSelector from "~/hooks/use-app-selector.ts";
import { selectUser } from "~/features/user/selectors.ts";
import LoginOrSignUpForm from "~/features/nav/login-or-sign-up-form.tsx";

type EmailCollectionStepProps = {
	readonly previouslyCollectedName?: string;
	readonly onGuestLogin: () => void;
};

export default function EmailCollectionStep({
	previouslyCollectedName,
	onGuestLogin,
}: EmailCollectionStepProps) {
	const user = useAppSelector(selectUser);

	const isOtpFlow =
		user.type === "waitingForOtp" || user.type === "verifyingOtp";

	return (
		<div className="get-started-step">
			<div className="get-started-content">
				<h1 className="get-started-title">
					{isOtpFlow
						? "Enter verification code"
						: previouslyCollectedName
							? `Great to meet you, ${previouslyCollectedName}!`
							: "Great to meet you!"}
				</h1>
				{!isOtpFlow && (
					<p className="get-started-subtitle">
						We&apos;ll use your email to save your progress.
					</p>
				)}

				<LoginOrSignUpForm
					showJustSignedUpMessage={true}
					finalSubmitLabel="Continue"
					previouslyCollectedName={previouslyCollectedName}
				>
					<div className="guest-option">
						<button
							className="guest-button"
							onClick={onGuestLogin}
							type="button"
						>
							Continue without an account
						</button>
					</div>
				</LoginOrSignUpForm>
			</div>
		</div>
	);
}
